const initialState = {
  reactModal: false
}

export const reactModal = (state = initialState, action) => {
  switch (action.type) {
    case "REACT_MODAL_ACTION":
      return { ...state, reactModal: action.val }

    default:
      return state
  }
}
